"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevourIQGetStoreAvailabilityResponseToJSON = exports.DevourIQGetStoreAvailabilityResponseFromJSONTyped = exports.DevourIQGetStoreAvailabilityResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function DevourIQGetStoreAvailabilityResponseFromJSON(json) {
    return DevourIQGetStoreAvailabilityResponseFromJSONTyped(json, false);
}
exports.DevourIQGetStoreAvailabilityResponseFromJSON = DevourIQGetStoreAvailabilityResponseFromJSON;
function DevourIQGetStoreAvailabilityResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'storeUuuid': !(0, runtime_1.exists)(json, 'storeUuuid') ? undefined : json['storeUuuid'],
        'isOpen': !(0, runtime_1.exists)(json, 'isOpen') ? undefined : json['isOpen'],
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : (json['items'].map(_1.DevourIQGetItemAvailabilityResponseFromJSON)),
    };
}
exports.DevourIQGetStoreAvailabilityResponseFromJSONTyped = DevourIQGetStoreAvailabilityResponseFromJSONTyped;
function DevourIQGetStoreAvailabilityResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'storeUuuid': value.storeUuuid,
        'isOpen': value.isOpen,
        'items': value.items === undefined ? undefined : (value.items.map(_1.DevourIQGetItemAvailabilityResponseToJSON)),
    };
}
exports.DevourIQGetStoreAvailabilityResponseToJSON = DevourIQGetStoreAvailabilityResponseToJSON;
